/* eslint-disable camelcase */
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReportUsageContext } from 'src/pages/reportUsage';
import QuestionCard from '../../questionCard/QuestionCard';
import QuestionDropDown from '../../questionDropDown';
import {
    Questions,
    DropDownOption,
    pjkUsageQuestions,
    questionAfterPjk,
} from './constant';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import {
    saveOrReportDetails,
    setReportUsageFormObject,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import PatientInformation from 'src/pages/reportUsage/common/patientInformation/PatientInformation';
import { TitleComponent } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { generateORreportRequestObject } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SurgeryOrReport = () => {
    const dispatch = useDispatch();
    const {
        usageDetails,
        reportUsageFormObj,
        setReportUsageFormObj,
        footerButtonStatuses,
        setFooterButtonStatuses,
    } = useContext(ReportUsageContext);

    const [questionSet, setQuestionSet] = useState(
        usageDetails?.isPjkOrder === 'Y'
            ? uidOrReportForm.pjkPerformed != '' && uidOrReportForm.pjkPerformed
                ? [...pjkUsageQuestions(), ...questionAfterPjk()]
                : pjkUsageQuestions()
            : Questions()
    );

    const { uidOrReportForm } = useSelector(({ reportUsageRootReducer }) => ({
        uidOrReportForm: reportUsageRootReducer.uidOrReportForm,
    }));

    const { t } = useTranslation();
    const btnDisableBasedOnIspjkOrder =
        usageDetails?.ispjkOrder === 'Y'
            ? uidOrReportForm.pjkPerformed !== '' &&
              uidOrReportForm.pjkPerformed
                ? uidOrReportForm.pjkPerformed === '' ||
                  uidOrReportForm.pjkMdtInstructed === '' ||
                  uidOrReportForm.pjkMdtImplants === '' ||
                  uidOrReportForm.isSurgeonSatisfied === '' ||
                  uidOrReportForm.isRodBentInSagittalPlan === '' ||
                  uidOrReportForm.isSurgeonCutTheRod === '' ||
                  uidOrReportForm.isChangeToInterbodiesAndOrPSOs === '' ||
                  uidOrReportForm.isSurgicalPlanChanged === '' ||
                  uidOrReportForm.isLevelOfInstrumentationChanged === ''
                : uidOrReportForm.pjkPerformed === '' ||
                  uidOrReportForm.isSurgeonSatisfied === '' ||
                  uidOrReportForm.isRodBentInSagittalPlan === '' ||
                  uidOrReportForm.isSurgeonCutTheRod === '' ||
                  uidOrReportForm.isChangeToInterbodiesAndOrPSOs === '' ||
                  uidOrReportForm.isSurgicalPlanChanged === '' ||
                  uidOrReportForm.isLevelOfInstrumentationChanged === ''
            : usageDetails?.ispjkOrder &&
              usageDetails?.ispjkOrder !== '' &&
              (uidOrReportForm.pjkMdtInstructed === '' ||
                  uidOrReportForm.pjkMdtImplants === '' ||
                  uidOrReportForm.isSurgeonSatisfied === '' ||
                  uidOrReportForm.isRodBentInSagittalPlan === '' ||
                  uidOrReportForm.isSurgeonCutTheRod === '' ||
                  uidOrReportForm.isChangeToInterbodiesAndOrPSOs === '' ||
                  uidOrReportForm.isSurgicalPlanChanged === '' ||
                  uidOrReportForm.isLevelOfInstrumentationChanged === '');

    useDynatracePageName(pageNames.reportUsageSurgeryOrReport);

    useEffectWithErrorLogging(() => {
        if (usageDetails?.ispjkOrder && usageDetails?.ispjkOrder === 'Y') {
            uidOrReportForm.pjkPerformed != '' && uidOrReportForm.pjkPerformed
                ? setQuestionSet([
                      ...pjkUsageQuestions(),
                      ...questionAfterPjk(),
                  ])
                : setQuestionSet(pjkUsageQuestions());
        } else if (
            usageDetails?.ispjkOrder &&
            usageDetails?.ispjkOrder !== ''
        ) {
            setQuestionSet(Questions());
            dispatch(
                saveOrReportDetails({
                    ['pjkPerformed']: true,
                })
            );
        } else {
            let filteredQuestions = Questions().filter(
                (question) => question.id <= 6
            );
            setQuestionSet(filteredQuestions);
        }
    }, [usageDetails]);
    useEffectWithErrorLogging(() => {
        if (
            usageDetails &&
            usageDetails.unidOrReportForm &&
            Object.keys(usageDetails.unidOrReportForm).length > 0
        ) {
            dispatch(saveOrReportDetails(usageDetails.unidOrReportForm));
        }
    }, [usageDetails]);

    useEffectWithErrorLogging(() => {
        if (uidOrReportForm) {
            const {
                isSurgicalPlanChanged,
                isLevelOfInstrumentationChanged,
                isChangeToInterbodiesAndOrPSOs,
                isSurgeonCutTheRod,
                isRodBentInSagittalPlan,
                isSurgeonSatisfied,
            } = uidOrReportForm;
            usageDetails?.ispjkOrder && usageDetails?.ispjkOrder === 'Y'
                ? setFooterButtonStatuses(
                      footerButtonStatuses.map((x) =>
                          x.btnName !==
                              t(
                                  'reportUsage.reportUsageFooterbuttons.cancelButton'
                              ) &&
                          x.btnName !==
                              t(
                                  'reportUsage.reportUsageFooterbuttons.saveAndExitButton'
                              ) &&
                          x.btnVisibility
                              ? {
                                    ...x,
                                    isBtnDisable: btnDisableBasedOnIspjkOrder,
                                }
                              : x
                      )
                  )
                : setFooterButtonStatuses(
                      footerButtonStatuses.map((x) =>
                          x.btnName !==
                              t(
                                  'reportUsage.reportUsageFooterbuttons.cancelButton'
                              ) &&
                          x.btnName !==
                              t(
                                  'reportUsage.reportUsageFooterbuttons.saveAndExitButton'
                              ) &&
                          x.btnVisibility
                              ? {
                                    ...x,
                                    isBtnDisable:
                                        isSurgicalPlanChanged === '' ||
                                        isLevelOfInstrumentationChanged ===
                                            '' ||
                                        isChangeToInterbodiesAndOrPSOs === '' ||
                                        isSurgeonCutTheRod === '' ||
                                        isSurgeonSatisfied === '' ||
                                        isRodBentInSagittalPlan === '' ||
                                        btnDisableBasedOnIspjkOrder,
                                }
                              : x
                      )
                  );
            if (
                Object.keys(generateORreportRequestObject(uidOrReportForm))
                    .length > 0
            ) {
                const orReport = generateORreportRequestObject(
                    uidOrReportForm,
                    usageDetails
                );
                if (
                    usageDetails?.ispjkOrder &&
                    usageDetails?.ispjkOrder !== '' &&
                    usageDetails?.ispjkOrder !== 'Y'
                ) {
                    orReport.pjkPerformed = true;
                }
                setReportUsageFormObj({
                    ...reportUsageFormObj,
                    unidOrReportForm: orReport,
                });
            }
        }
    }, [uidOrReportForm]);

    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);

    const handleOnChange = (question, value) => {
        let new_value = value === 'Yes' ? true : false;
        updateObject(question, question.field_name, new_value);
        // setQuestion1({
        //     ...question1,
        //     [question.field_name]: new_value,
        // });
        if (usageDetails?.ispjkOrder && usageDetails?.ispjkOrder != 'Y') {
            dispatch(
                saveOrReportDetails({
                    [question.field_name]: new_value,
                })
            );
        } else {
            question.field_name === 'pjkPerformed' && !new_value
                ? dispatch(
                      saveOrReportDetails({
                          [question.field_name]: new_value,
                          pjkMdtInstructed: '',
                          pjkMdtImplants: '',
                      })
                  )
                : dispatch(
                      saveOrReportDetails({
                          [question.field_name]: new_value,
                      })
                  );
        }
    };

    const handleInputChange = (question, value) => {
        updateObject(question, question.option_field_name, value);
        dispatch(
            saveOrReportDetails({
                [question.option_field_name]: value,
            })
        );
    };
    const updateObject = (question, field_name, value) => {
        let previousQuestionSet = null;
        // field_name === 'pjkPerformed' && value
        //     ? [...questionSet, ...questionAfterPjk]
        //     : pjkUsageQuestions;
        if (field_name === 'pjkPerformed') {
            previousQuestionSet = value
                ? [...questionSet, ...questionAfterPjk()]
                : pjkUsageQuestions();
        } else {
            previousQuestionSet = questionSet;
        }
        let previousObject = previousQuestionSet[question.id - 1];
        let newObject = {
            ...previousObject,
            [field_name]: value,
        };
        previousQuestionSet[question.id - 1] = newObject;
        setQuestionSet(previousQuestionSet);
    };
    const onDropDownChange = (data) => {
        const { field, value } = data;
        if (field === 'UIV') {
            dispatch(
                saveOrReportDetails({
                    uiv: value,
                })
            );
        } else {
            dispatch(
                saveOrReportDetails({
                    liv: value,
                })
            );
        }
    };
    return (
        <>
            <TitleComponent>
                {t(
                    'reportUsage.procedure.unidSurgery.SurgeryOrReport.titleComponent'
                )}
            </TitleComponent>
            <PatientInformation title={t('common.patientDetails')} />
            {questionSet.map((item, index) => (
                <>
                    <QuestionCard
                        isChecked={uidOrReportForm[item.field_name]}
                        question={item.question}
                        onChange={(value) => handleOnChange(item, value)}
                        isLastCard={index === questionSet.length - 1}
                    >
                        {uidOrReportForm[item.field_name] ? (
                            item.id === '3' ||
                            item.id === '4' ||
                            item.id === '5' ? (
                                <>
                                    <Notes
                                        id="pricingNoteDivId"
                                        placeholder={item.placeholder}
                                        // onKeyPress={handlePopupOnKeyPress}
                                        width={'533px'}
                                        title={item.option_question}
                                        margin={
                                            window.innerWidth <
                                            sizes.mobileDevice
                                                ? '10px 0 0 0'
                                                : '10px 24px 0 0'
                                        }
                                        note={
                                            uidOrReportForm[
                                                item.option_field_name
                                            ]
                                        }
                                        fontSize={'14px'}
                                        placeholderFont={'12px'}
                                        placeholderFontFamily={
                                            'AvenirNextWorld Regular'
                                        }
                                        updateNotes={(value) =>
                                            handleInputChange(item, value)
                                        }
                                        helperText={` ${t(
                                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.max'
                                        )} ${
                                            250 -
                                                uidOrReportForm[
                                                    item.option_field_name
                                                ]?.length <
                                            0
                                                ? 0
                                                : 250 -
                                                  uidOrReportForm[
                                                      item.option_field_name
                                                  ].length
                                        } ${t(
                                            'reportUsage.procedure.unidSurgery.SurgeryOrReport.Characters'
                                        )}`}
                                        helperTextFont={
                                            'AvenirNextWorld Italic'
                                        }
                                        ipadWidth={'100%'}
                                        maxLength={250}
                                        autoResize={false}
                                        isScrollBar={true}
                                        isTextAreaResize={false}
                                        row={2}
                                        boxShadow="none"
                                        cardHeaderMargin={'0px'}
                                        contentBodyMargin={'0px'}
                                        justifyContent={'flex-end'}
                                    />
                                </>
                            ) : item.id === '2' ? (
                                <QuestionDropDown
                                    uiv={uidOrReportForm.uiv}
                                    liv={uidOrReportForm.liv}
                                    onChange={onDropDownChange}
                                    options={DropDownOption}
                                    dropLabelFirst={t(
                                        'reportUsage.procedure.unidSurgery.questionDropDown.uiv'
                                    )}
                                    dropLabelSecond={t(
                                        'reportUsage.procedure.unidSurgery.questionDropDown.LIV'
                                    )}
                                />
                            ) : null
                        ) : null}
                    </QuestionCard>
                </>
            ))}
        </>
    );
};

export default SurgeryOrReport;
